import styled from '@emotion/styled';

export const StyledIcon = styled.img<{ size: number; imageLoaded: boolean }>`
	height: ${props => `${props.size}px`};
	width: ${props => `${props.size}px`};
	min-height: ${props => `${props.size}px`};
	min-width: ${props => `${props.size}px`};
	display: ${props => (props.imageLoaded ? 'block' : 'none')};
`;
